module.exports = __webpack_public_path__ + "static/media/shrink.79afc189.svg";